export default __webpack_public_path__ + "static/Mongo_DB-08ca3d9dec267a30e13778bc7e0e2dd8.webp";